import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments = z.array(
    LoanRequestsTableDefinitionZod.omit({ antragsteller1: true }).merge(
        z.object({
            antragsteller1: LoanRequestsTableDefinitionZod.shape.antragsteller1.unwrap(),
            /** Timestamp of the most recently uploaded still-unverified document (epoch millis). */
            newestUnverifiedDocumentDate: z.number(),
            unverifiedDocuments: z.number(),
        }),
    ),
);

export type SchemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments = z.infer<
    typeof schemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments
>;

export type LoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments
>;
